import React from 'react';
import { useEffect } from 'react';
import { simpleGetCall } from '../api/ApiServices';
import ApiConfig from '../api/ApiConfig';
import { useState } from 'react';



const AboutUsDescp = () => {
    const [aboutUsTxt, setAboutUsTxt] = useState([]);

    const fetchAboutUS = () => {
        simpleGetCall(ApiConfig.GET_ABOUT_US)
            .then((data) => {
                setAboutUsTxt(data.commonText);
                // setLoading(false);
                console.log("Privacy Data", data.commonText);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchAboutUS();
    }, []);

    return (
        <div className='logout_aboutUs'>
            <div className='innerCardAbt'>
                <h2 className='headingTxt'>About Us Description</h2>
                <label className='InsideTxt'>{aboutUsTxt}</label>
            </div>
        </div>

    )
}

export default AboutUsDescp;
